module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
  title: 'Secure delivery of serverless applications | Stackery', // Navigation and Site Title
  titleAlt: 'Stackery', // Title for JSONLD
  description: 'Modern Applications. Built Fast. Delivered Securely.',
  url: 'https://www.stackery.io', // Domain of your site. No trailing slash!
  siteUrl: 'https://www.stackery.io', // url + pathPrefix
  siteLanguage: 'en', // Language Tag on <html> element
  logo: 'logo/logo.svg', // Used for SEO
  banner: 'https://www.stackery.io/assets/images/stackery-article-full.png',
  // JSONLD / Manifest
  favicon: 'logo/favicon.png', // Used for manifest favicon generation
  shortName: 'Stackery', // shortname for manifest. MUST be shorter than 12 characters
  author: 'Stackery', // Author for schemaORGJSONLD
  themeColor: '#79CCB5',
  backgroundColor: '#fff',
  twitter: '@stackeryio' // Twitter Username
};
